import styled from 'styled-components';

import type { CommonSeparatorProps } from '@wecasa/common/src/types/components';
import colors from '@wecasa/common/src/utils/colors';

import Text from '../base-text/variants/text';
import type { WithClassNameProps } from '../types';

const StyledSeparator = styled.div<{
  $thickness?: number;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;

  &::before,
  &::after {
    content: ' ';
    width: 100%;
    border-bottom: ${({ $thickness }) => `${$thickness}px solid ${colors.ink20}`};
  }
`;
const StyledText = styled(Text.SM)`
  margin: 0 10px;
`;

export type SeparatorProps = WithClassNameProps & CommonSeparatorProps;

const Separator = ({ className, text, thickness = 1 }: SeparatorProps) => (
  <StyledSeparator role='separator' className={className} $thickness={thickness}>
    {text && <StyledText>{text}</StyledText>}
  </StyledSeparator>
);

export default Separator;
